import React from 'react';
import AccountListWithoutAdmin from "../../components/AccountListWithoutAdmin/AccountListWithoutAdmin";

const CustomerAccountsWithoutAdmin = () => (
    <AccountListWithoutAdmin />
);

export default CustomerAccountsWithoutAdmin;
